import React from "react";
import resumeFile from "../documents/Ifran_Ali_Resume.pdf";
const AboutUs = ({ classicHeader, darkTheme }) => {
  return (
    <section id="about" className={"section " + (darkTheme ? "bg-dark-1" : "")}>
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            About Me
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            Code. Create. Evolve.
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        <div className="row gy-5">
          {/* About me content start */}
          <div className="col-lg-7 col-xl-8 text-center text-lg-start">
            <h2
              className={
                "text-7 fw-600 mb-3 " + (darkTheme ? "text-white" : "")
              }
            >
              I'm <span className="text-primary">Ifran Ali,</span> a Full Stack
              Developer
            </h2>
            <p className={darkTheme ? "text-white-50" : ""}>
              Full‑stack Software Engineer with strong experience in Python,
              React, and cloud infrastructure (AWS, Azure). Proven success in
              building scalable systems for network resilience, automation, and
              distributed platforms.
            </p>
            <p className={darkTheme ? "text-white-50" : ""}>
              Passionate about continuous learning, iterative delivery, and
              mentoring teams in clean architecture and DevOps best practices.
            </p>
          </div>
          {/* About me content end */}
          {/* about me personal detials start */}
          <div className="col-lg-5 col-xl-4">
            <div className="ps-lg-4">
              <ul
                className={
                  "list-style-2 " +
                  (darkTheme ? "list-style-light text-light" : "")
                }
              >
                <li>
                  <span className="fw-600 me-2">Name:</span>Ifran Aiyub Ali
                </li>
                <li>
                  <span className="fw-600 me-2">Email:</span>
                  <a href="mailto:ifranaiyubali@gmail.com">
                    ifranaiyubali@gmail.com
                  </a>
                </li>
                <li>
                  <span className="fw-600 me-2">Github:</span>
                  <a href="https://github.com/ifranaiyubali">ifranaiyubali</a>
                </li>
                <li>
                  <span className="fw-600 me-2">LinkedIn:</span>
                  <a href="https://www.linkedin.com/in/ifran-aiyub-ali-b6029a124/">
                    ifran-ali-b6029a124
                  </a>
                </li>
                <li className="border-0">
                  <span className="fw-600 me-2">From:</span>Brisbane, Australia,
                  QLD
                </li>
              </ul>
              <a
                href={resumeFile}
                download
                className="btn btn-primary rounded-pill"
              >
                Download CV
              </a>
            </div>
          </div>
          {/* about me personal details end */}
        </div>
        {/* projects rewards counting start */}
        <div
          className={
            "brands-grid separator-border mt-5 " +
            (darkTheme ? "separator-border-light" : "")
          }
        >
          <div className="row">
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>5</span>+
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Years Experiance
                </p>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Hands-on in software engineering, automation, and full-stack
                  development.
                </p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>20</span>+
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Enterprise Projects Delivered.
                </p>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Deployed cloud, automation, and network solutions at scale.
                </p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>10</span>+
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Technologies Mastered.
                </p>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Python, React, TypeScript, AWS, Azure, Docker, Django, etc.
                </p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>3</span>
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Major Product Releases per Year.
                </p>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Regular releases at OpenGear with continuous feedback
                  integration.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* projects rewards counting end */}
      </div>
    </section>
  );
};

export default AboutUs;
